export const yesNo = [
  { value: 1, label: '是' },
  { value: 0, label: '否' }
];

export default {

};
